import useClickOutside from 'hooks/useClickOutside';
import React, { PropsWithChildren, useEffect, useRef } from 'react';
import CloseButton from 'reusable-components/buttons/CloseButton';
import Overlay from 'reusable-components/dialogs/Overlay';

const CSS = require('./Sheet.module.scss');

interface SheetProps {
  onClose: () => void;
  title: string | React.ReactNode;
  showClose?: boolean;
  onReset?: () => void;
  variant?: 'sandstone' | 'white';
  footer?: React.ReactNode;
}

function Sheet({
  onClose,
  title,
  children,
  showClose,
  onReset,
  variant = 'sandstone',
  footer,
}: PropsWithChildren<SheetProps>) {
  const dialogRef = useRef<HTMLDialogElement>(null);
  useClickOutside(dialogRef, onClose);

  useEffect(() => {
    const dialogElement = dialogRef.current;
    if (dialogElement) {
      dialogElement.focus();
    }
  }, []);

  return (
    <Overlay
      portalId="sheetDialog"
      onEsc={onClose}
      containerSize="small"
      noPadding
    >
      <dialog
        className={CSS.Sheet}
        data-variant={variant}
        ref={dialogRef}
        tabIndex={-1}
      >
        <header className={CSS.SheetHeader}>
          {onReset && (
            <button className={CSS.ResetButton} onClick={onReset}>
              Reset
            </button>
          )}
          {!showClose && !onReset && (
            <button className={CSS.CancelButton} onClick={onClose}>
              Cancel
            </button>
          )}
          <h1 className={CSS.SheetTitle}>{title}</h1>
          {showClose && <CloseButton onClick={onClose} />}
        </header>
        <section className={CSS.SheetBody}>{children}</section>
        {footer}
      </dialog>
    </Overlay>
  );
}

export default Sheet;
